import React from "react";
import HeroQuoteOpen from "../../../assets/svgs/HeroQuoteOpen.svg";
import HeroQuoteClose from "../../../assets/svgs/HeroQuoteClose.svg";
import Image from "../../atoms/Image/Image.atom";
import { StoryblokAsset } from "../../../interfaces/Storyblok/StoryblokAsset.interface";

interface HeroTestimonialProps {
  image?: StoryblokAsset;
  title?: string;
  description?: string;
  sub_text?: string;
}

const HeroTestimonial: React.FC<HeroTestimonialProps> = ({ image, title, description, sub_text }) => {
  return (
    <div className="bg-Primary-50">
      <div className="container mx-auto py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-16">
          {/*-- portrait --*/}
          {image?.filename && (
            <div className="overflow-hidden rounded-[24px] shadow-xl">
              <div className="aspect-[4/3] h-full w-full">
                <Image image={image} objectFit="cover" fluidMaxWidth={960} />
              </div>
            </div>
          )}

          {/*-- quote --*/}
          <div className="flex flex-col">
            <HeroQuoteOpen className="fill-SP2" />

            {description && (
              <p className="mt-4 text-[20px] font-semibold leading-relaxed text-SP6">{description}</p>
            )}

            <div className="mt-8 flex items-end justify-between gap-6">
              <div>
                {title && <p className="text-base font-extrabold uppercase tracking-wide text-Primary-900">{title}</p>}
                {sub_text && (
                  <p className="mt-1 text-base font-semibold uppercase tracking-wide text-Primary-900">{sub_text}</p>
                )}
              </div>
              <HeroQuoteClose className="shrink-0 fill-SP2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroTestimonial;
